import { Sound } from '@/classes';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useFocusElement } from '@/hooks/useFocusElement';
import { FocusableComponentLayout } from '@noriginmedia/norigin-spatial-navigation';
import { DetailedHTMLProps, ImgHTMLAttributes, useCallback } from 'react';

export const FocusableImage = ({
  focusKey,
  onNavigationFocus,
  ...props
}: DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  onNavigationFocus?: ({ left, x, top }: FocusableComponentLayout) => void;
  focusKey?: string;
}) => {
  const { ref, focused } = useExtendFocusable({ focusKey, onFocus: onNavigationFocus });
  const handleClick = useCallback(() => {
    Sound.press();
    if (props.onClick) {
      (props.onClick as any)();
    }
  }, [props.onClick]);

  useFocusElement({ ref, focused: focused, onClick: handleClick, keyCode: 13 });

  return <img tabIndex={0} ref={ref} {...props} onClick={handleClick} onContextMenu={handleClick} />;
};
